import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Typography from '@mui/material/Typography';
import type { ReactElement, ReactNode } from 'react';

export type CheckoutSectionCardProps = {
    title: string;
    children: ReactNode;
};

export function CheckoutSectionCard({ title, children }: CheckoutSectionCardProps): ReactElement {
    return (
        <Card variant="outlined">
            {/* MUI drops every variant's letterSpacing when the theme sets a non-default fontFamily, so the
                tracking the design asks for has to be restated wherever it matters. */}
            <CardHeader
                sx={{ p: 2, pb: 0 }}
                title={
                    <Typography variant="overline" color="text.secondary" sx={{ letterSpacing: '1px' }}>
                        {title}
                    </Typography>
                }
            />
            <CardContent sx={{ px: 2, pt: 2, pb: 2, '&:last-child': { pb: 2 } }}>{children}</CardContent>
        </Card>
    );
}
